import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { setContactGroup, resetProgress } from '../../store/actions/broadcastAction';
import { useHistory } from 'react-router-dom'
import { Grid, Typography, Button, Box } from '@material-ui/core';
import LinearProgress from '@mui/material/LinearProgress';

const AddGrup3 = ({contact, group}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [progress, setProgress] = useState(0);
  const [isDisabled, setIsDisabled] = useState(true)
  
  const progress_status = useSelector(state => state.broadcastReducer.progress_status)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);
  }, []);

  useEffect(() => {
    const payload = {
      option: group.option,
      groupId: group.groupId,
      groupName: group.groupName,
      contactLists: contact
    }
    if ((payload.groupName && payload.contactLists) || (payload.groupId && payload.contactLists)) {
      dispatch(setContactGroup(payload))
    }
  }, [dispatch, contact, group]);

  useEffect(() => {
    if (progress_status) {
      setIsDisabled(false)
    }

    return (
      dispatch(resetProgress())
    )
  }, [dispatch, progress_status]);

  const handleContactHome = () => {
    history.push('/broadcast/group')
  }

  return (
      <Grid container spacing={3} style={{justifyContent: "center"}}>
        <Grid item xs={12} md={12}>
          <Typography className="text-center font-size-14 mb-5 bold">
            Menambahkan Kontak Anda
          </Typography>
        </Grid>

        <Grid item xs={12} md={12} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <img src="/icon-done-upload.png"/>
        </Grid>
        <Grid item xs={4} md={4}>
          <Box className='mb-5' sx={{ width: '60%', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Typography className="text-center font-size-14 mb-5 bold">
            {
              progress_status ? 'Sedang diproses' : 'Done'
            }
          </Typography>
        </Grid>
        <Grid item xs={12} md={12} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <Button
            type="submit"
            // className="btn-black text-transform-unset"
            className={isDisabled? "btn-grey text-grey text-transform-unset" : "btn-black text-transform-unset" }
            spacing={5}
            disabled={isDisabled}
            onClick={handleContactHome}
            // style={{padding: "5px 40px"}}
            style={{fontSize:'10px', height:'25px', width:'150px'}}
          >
            Kembali ke Kontak Grup
          </Button>
        </Grid>
    </Grid>
  );
}

export default AddGrup3